// extracted by mini-css-extract-plugin
export default {"wrap":"Landing_wrap__ZSyC8","duo":"Landing_duo__LEWZI","text-container":"Landing_text-container__MhNA6","title":"Landing_title__OFs58","subtitle":"Landing_subtitle__rdXLp"};